import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Mohd Aquib </span>
            from <span className="purple"> Delhi, India.</span>
            <br/>
            I am a recent graduate with a BTech in Electrical and Electronics Engineering from Maharaja Agrasen Institute Of Technology(GGSIPU). I am eager to start my career and I am looking for an opportunity to contribute to a team and make a difference. I am a hard worker and I am eager to learn new things. I am also a team player and I am able to work independently.
            
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching Movies
            </li>
            <li className="about-activity">
              <ImPointRight /> Calligraphy
            </li>
          </ul>

          {/* <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p> */}
          {/* <footer className="blockquote-footer">~SOMEONE</footer> */}
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;